export default "__VITE_ASSET__C5W5MrYg__"